import { styled } from '@mui/material';
import { useOverviewState } from '../useOverviewProvider';
import SummaryBox from './SummaryBox';

const StyledContainer = styled('div')(
    ({ theme: { spacing, palette, typography, shape } }) => ({
        display: 'flex',
        gap: spacing(1),
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '24px 20px',

        '@media screen and (max-width: 1024px)': {
            flexWrap: 'wrap',
            justifyContent: 'flex-start'
        },

        '@media screen and (max-width: 768px)': {
            flexWrap: "wrap"
        }
    })
);

const info = {
    "totalEmployees": {
        description: 'Total Employee',
        color: "db_overview_1",
        status: 'all'
    },
    "totalPresent": {
        description: 'Present',
        color: "db_overview_2",
        status: "in"
    },
    "totalAbsent": {
        description: 'Absent',
        color: "db_overview_3",
        status: "absent"
    },
    "totalLate": {
        description: 'Late to join',
        color: "db_overview_4",
        status: "arrivedLate"
    },
    // One box for every leave category. The split lives in the modal, which
    // groups the rows by category, rather than in two boxes that could only
    // ever say "sick" and "not sick".
    "totalLeave": {
        description: 'Leaves',
        color: "db_overview_5",
        status: "leave"
    },
    "totalInOffice": {
        description: 'In office',
        color: "db_overview_6",
        status: "inOffice"
    },
    "totalRemote": {
        description: 'Joined Remotely',
        color: "db_overview_7",
        status: "remote",
    }
}

const DataTable = () => {
    const { overviewSummary } = useOverviewState();
    return (
        <StyledContainer>
            {
                Object.entries(info).map(([key, value]) => {
                    value = {
                        ...value,
                        present: overviewSummary[key] ? overviewSummary[key] : 0,
                        total: overviewSummary.totalEmployees ? overviewSummary.totalEmployees : 0,
                        developerCount: overviewSummary.developerCount || 0,
                        qaCount: overviewSummary.qaCount || 0,
                        managerCount: overviewSummary.managerCount || 0,
                        projectManagerCount: overviewSummary.projectManagerCount || 0,
                        designerCount: overviewSummary.designerCount || 0,
                        hrCount: overviewSummary.hrCount || 0,
                        adminCount: overviewSummary.adminCount || 0,
                        otherCount: overviewSummary.otherCount || 0
                    }

                    return (<SummaryBox key={key} data={value} />)
                })
            }
        </StyledContainer>
    );
};

export default DataTable;
